import { createSelector } from 'reselect';

const getSupportPageKeys = (state) => state.app.contextualSupport.supportPageKeys;

const getSupportVisible = (state) => state.app.contextualSupport.visible;

export const getSupportPageKey = createSelector([getSupportPageKeys], (supportPageKeys) =>
  supportPageKeys.length > 0 ? supportPageKeys[supportPageKeys.length - 1] : null,
);

export const getSupportVisibility = createSelector([getSupportVisible], (visible) => visible);

export const getResourceEditModalOpen = (state) =>
  state.app.activeViews?.resourceEditModalOpen === true;

export const getCurrentProjectId = (state) => {
  const result = state.app.currentProject.currentProjectId;
  // Only log when the value changes
  if (result !== getCurrentProjectId._lastValue) {
    getCurrentProjectId._lastValue = result;
  }
  return result;
};
